import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on every route change — expected behaviour for a
// multi-page site (as opposed to the anchor-scrolling of a single page).
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
